import AlertPage from "components/common/AlertPage";
import React, { useState } from "react";
import { Alert } from "react-ionicons";
import { Helmet } from 'react-helmet';

const Page404 = () => {
  return (
    <div className="page-content">
      <Helmet>
        <title>Arras | Page non trouvée</title>
        <meta name="description" content="La page que vous recherchez n’a pas été trouvée ou n’existe pas." />
        <meta property="og:title" content="Arras | Page non trouvée" />
        <meta property="og:description" content="La page que vous recherchez n’a pas été trouvée ou n’existe pas." />
        <link rel="canonical" href={`https://www.arras.fr/404`} />
      </Helmet>
      <AlertPage title={"Oups"} description={"La page que vous recherchez n’a pas été trouvée ou n’existe pas."} />
    </div>
  );
};

export default Page404;
